import { Eye16, NotVisible16 } from '@ingrid/iconography/react';
import { IconButton, type IconButtonProps } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

type Props = Omit<IconButtonProps, 'aria-label' | 'variant'> & {
  isShowing: boolean;
};

export function ToggleVisibilityButton(props: Props) {
  const { isShowing, ...rest } = props;
  const { t } = useTranslation();

  return (
    <IconButton
      aria-label={t(isShowing ? 'common.hideItem' : 'common.showItem', { item: 'password' })}
      variant="quaternary"
      {...rest}
    >
      {!isShowing ? <Eye16 /> : <NotVisible16 />}
    </IconButton>
  );
}
